module.exports = __webpack_public_path__ + "static/media/appointedd.69d8330e.png";